module["exports"] = [
  "آقای",
  "خانم",
  "دکتر"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fa/name/prefix.js
// module id = 2302
// module chunks = 2